'use client';

import Script from 'next/script';

interface DatadogRumScriptProps {
  appEnv: string;
  clientToken: string;
  applicationId: string;
  site?: string;
  service: string;
  version?: string;
  sessionSampleRate?: number;
  sessionReplaySampleRate?: number;
  trackBfcacheViews?: boolean;
  defaultPrivacyLevel?: 'mask-user-input' | 'mask' | 'allow';
}

export default function DatadogRumScript(
  props: Readonly<DatadogRumScriptProps>
) {
  const {
    appEnv,
    clientToken,
    applicationId,
    site = 'datadoghq.com',
    service,
    version,
    sessionSampleRate = 100,
    sessionReplaySampleRate = 20,
    trackBfcacheViews = true,
    defaultPrivacyLevel = 'mask-user-input',
  } = props;

  if (appEnv === 'local') return null;

  const startRum = () => {
    const dd: any = (window as any).DD_RUM;
    if (!dd || typeof dd.onReady !== 'function') return;
    dd.onReady(function () {
      dd.init({
        clientToken,
        applicationId,
        site,
        service,
        env: appEnv,
        ...(version ? { version } : {}),
        sessionSampleRate,
        sessionReplaySampleRate,
        trackBfcacheViews,
        defaultPrivacyLevel,
      });
    });
  };

  return (
    <Script
      src="https://www.datadoghq-browser-agent.com/us1/v6/datadog-rum.js"
      strategy="afterInteractive"
      onReady={startRum}
    />
  );
}
